import type { FeatureVariant } from "../../data/siteContent";
import { useLocale } from "../../i18n/LocaleProvider";
import { SCREENSHOT_SRC } from "../../data/siteAssets";

import styles from "./AppScreenshot.module.css";

type AppScreenshotProps = {
  variant: FeatureVariant;
  className?: string;
  displayWidth?: number;
  decorative?: boolean;
};

function join(...parts: (string | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

export function AppScreenshot({
  variant,
  className,
  displayWidth,
  decorative = false,
}: AppScreenshotProps) {
  const { copy } = useLocale();

  return (
    <img
      className={join(
        styles.image,
        displayWidth !== undefined ? styles.fixedWidth : undefined,
        className,
      )}
      src={SCREENSHOT_SRC[variant]}
      alt={decorative ? "" : copy.screenshotAlt[variant]}
      style={
        displayWidth !== undefined
          ? { width: `${String(displayWidth)}px` }
          : undefined
      }
      loading="lazy"
      decoding="async"
      aria-hidden={decorative ? true : undefined}
    />
  );
}
